export enum SecurityType {
  TRADE = 'TRADE',
  ORDER = 'ORDER'
}
